"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePassword = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require("react-router-redux");

var _auth = require("../../redux/modules/auth");

var _ChangePasswordForm = require("../../components/password/ChangePasswordForm");

var _ChangePasswordForm2 = _interopRequireDefault(_ChangePasswordForm);

var _passwordValidator = require("./passwordValidator");

var _passwordValidator2 = _interopRequireDefault(_passwordValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChangePassword = exports.ChangePassword = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ChangePassword, _Component);

  function ChangePassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ChangePassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ChangePassword.__proto__ || (0, _getPrototypeOf2.default)(ChangePassword)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (values) {
      _this.props.passwordChange(values);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ChangePassword, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          pushRoute = _props.pushRoute,
          changePasswordSuccess = _props.auth.changePasswordSuccess;

      if (!changePasswordSuccess && nextProps.auth.changePasswordSuccess) {
        pushRoute("/kirjaudu");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "col col-xs-12" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Vaihda Salasana" }),
        _react2.default.createElement(
          "h1",
          { className: "h3" },
          "Vaihda salasana"
        ),
        _react2.default.createElement(_ChangePasswordForm2.default, {
          fields: this.props.fields,
          handleSubmit: this.props.handleSubmit,
          onSubmit: this.submit,
          auth: this.props.auth,
          passwordToken: this.props.routeParams.passwordToken
        })
      );
    }
  }]);
  return ChangePassword;
}(_react.Component), _class.propTypes = {
  fields: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  passwordChange: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  auth: _react.PropTypes.object.isRequired,
  routeParams: _react.PropTypes.object.isRequired
}, _temp2);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}, {
  passwordChange: _auth.passwordChange,
  pushRoute: _reactRouterRedux.push
})((0, _reduxForm.reduxForm)({
  form: "changePassword",
  fields: ["password", "password2", "reset_password_token"],
  validate: _passwordValidator2.default
})(ChangePassword));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Password/ChangePassword.js
 ** module id = 1224
 ** module chunks = 0
 **/